import { render, staticRenderFns } from "./CTableHeaderColumn.vue?vue&type=template&id=6153f5aa&scoped=true&"
import script from "./CTableHeaderColumn.vue?vue&type=script&lang=js&"
export * from "./CTableHeaderColumn.vue?vue&type=script&lang=js&"
import style0 from "./CTableHeaderColumn.vue?vue&type=style&index=0&id=6153f5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6153f5aa",
  null
  
)

export default component.exports